import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  columnTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#344054",
    lineHeight: "20px",
  },
  checkboxLabel: {
    fontSize: 14,
    color: "#344054",
  },
}));
